import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import EmptyTable from "views/components/EmptyTable";

const TableRow = ({ component, index, onDelete }) => {
  const { t } = useTranslation();
  return (
    <tr key={index} role="row" className="odd">
      <td>{component.name || ""}</td>
      <td>{component.title || ""}</td>
      <td>{component.description || ""}</td>
      <td style={{ textAlign: "center" }}>
        <Link
          to={`/settings/config-rapport/edit/${component.name}`}
          className="btn btn-sm btn-clean btn-icon btn-icon-md"
          title={t("Modifier")}
        >
          <i className="la la-edit" />
        </Link>
        {/* Uncomment if delete functionality is needed
        <button
          onClick={(e) => onDelete(component.id, index)}
          className="btn btn-sm btn-clean btn-icon btn-icon-md"
          title="Supprimer"
        >
          <i className="la la-trash" />
        </button>
        */}
      </td>
    </tr>
  );
};

const ReportingTable = ({ component, showList, onDelete }) => {
  return (
    <table
      className="table table-striped table-bordered table-hover table-checkable dataTable dtr-inline"
      id="myTable"
      role="grid"
      aria-describedby="kt_table_1_info"
      style={{ width: "952px" }}
    >
      <thead>
        <tr role="row">
          <th
            className="sorting"
            tabIndex="0"
            aria-controls="kt_table_1"
            rowSpan="1"
            colSpan="1"
            style={{ width: "150px" }}
            aria-label="Type de Rapport: activate to sort column ascending"
          >
            Type de Rapport
          </th>
          <th
            className="sorting"
            tabIndex="0"
            aria-controls="kt_table_1"
            rowSpan="1"
            colSpan="1"
            style={{ width: "150px" }}
            aria-label="Titre du Rapport: activate to sort column ascending"
          >
            Titre du Rapport
          </th>
          <th
            className="sorting"
            tabIndex="0"
            aria-controls="kt_table_1"
            rowSpan="1"
            colSpan="1"
            style={{ width: "150px" }}
            aria-label="Description: activate to sort column ascending"
          >
            Description
          </th>
          <th
            className="sorting"
            tabIndex="0"
            aria-controls="kt_table_1"
            rowSpan="1"
            colSpan="1"
            style={{ width: "70.25px" }}
            aria-label="Action: activate to sort column ascending"
          >
            Action
          </th>
        </tr>
      </thead>
      <tbody>
        {component.length > 0 ? (
          showList.length > 0 ? (
            showList.map((item, index) => (
              <TableRow
                key={index}
                component={item}
                index={index}
                onDelete={onDelete}
              />
            ))
          ) : (
            <EmptyTable search={true} />
          )
        ) : (
          <EmptyTable />
        )}
      </tbody>
      <tfoot>
        <tr></tr>
      </tfoot>
    </table>
  );
};

export default ReportingTable;
